// extracted by mini-css-extract-plugin
export default {"loaderContainer":"styles_loaderContainer__LUCEx","transparentLoader":"styles_transparentLoader__yOCPW","loader":"styles_loader__8rU1t","spin":"styles_spin__CmySI"};